import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { userService } from "../../services/UserService";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import Skeleton from "@mui/material/Skeleton";

function DeletedUsersInfo() {
  const [t] = useTranslation();
  const [deactivatedAccountTotalCount, setDeactivatedAccountTotalCount] =
    useState<string>("0");
  const [deactivatedAccountLast30Days, setDeactivatedAccountLast30Days] =
    useState<string>("0");
  const [deactivatedAccountToday, setDeactivatedAccountToday] =
    useState<string>("0");
  const [showModal, setShowModal] = useState<boolean>(false);
  const [modalText, setModalText] = useState<string>("");
  const [modalType, setModalType] = useState<string>("error");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    fetchDeactivatedAccountCount();
  }, []);

  const handleModelClose = () => setShowModal(false);

  const fetchDeactivatedAccountCount = async () => {
    setIsLoading(true);
    const res = await userService.getDeactivatedUserCount();
    if (res) {
      setDeactivatedAccountTotalCount(res.totalDeactivatedUsers);
      setDeactivatedAccountLast30Days(res.deactivatedIn30Days);
      setDeactivatedAccountToday(res.deactivatedToday);
    } else {
      setModalType("error");
      setModalText(t("Something went wrong!"));
      setShowModal(true);
    }
    setIsLoading(false);
  };

  return (
    <>
      <div className="card border-0 shadow-sm rounded-1rem">
        <div className="card-body p-4">
          <h6 className="fw-bold text-primary">{t("Deleted Accounts")}</h6>
          <div className="p-4 skeleton">
            <div className="row">
              <div className="col-8">
                {isLoading ? (
                  <Skeleton variant="text" sx={{ fontSize: "3rem" }} />
                ) : (
                  <p className="fs-18 bg-success bg-opacity-10 border-0 rounded-10 p-2">
                    {t("Total Deleted Accounts")}
                  </p>
                )}
              </div>
              <div className="col-4">
                {isLoading ? (
                  <Skeleton variant="text" sx={{ fontSize: "3rem" }} />
                ) : (
                  <p className="fs-18 bg-success bg-opacity-10 border-0 rounded-10 p-2 fw-600">
                    {deactivatedAccountTotalCount}
                  </p>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-8">
                {isLoading ? (
                  <Skeleton variant="text" sx={{ fontSize: "3rem" }} />
                ) : (
                  <p className="fs-18 bg-info bg-opacity-10 border-0 rounded-10 p-2">
                    {t("Accounts Deleted In Last 30 Days")}
                  </p>
                )}
              </div>
              <div className="col-4">
                {isLoading ? (
                  <Skeleton variant="text" sx={{ fontSize: "3rem" }} />
                ) : (
                  <p className="fs-18 bg-info bg-opacity-10 border-0 rounded-10 p-2 fw-600">
                    {deactivatedAccountLast30Days}
                  </p>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-8">
                {isLoading ? (
                  <Skeleton variant="text" sx={{ fontSize: "3rem" }} />
                ) : (
                  <p className="fs-18 bg-warning bg-opacity-10 border-0 rounded-10 p-2">
                    {t("Accounts Deleted Today")}
                  </p>
                )}
              </div>
              <div className="col-4">
                {isLoading ? (
                  <Skeleton variant="text" sx={{ fontSize: "3rem" }} />
                ) : (
                  <p className="fs-18 bg-warning bg-opacity-10 border-0 rounded-10 p-2 fw-600">
                    {deactivatedAccountToday}
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {modalType === "error" && (
        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          open={showModal}
          autoHideDuration={3000}
          onClose={handleModelClose}
        >
          <Alert onClose={handleModelClose} severity="error">
            {modalText}
          </Alert>
        </Snackbar>
      )}
    </>
  );
}

export default DeletedUsersInfo;
